import { gql } from "@apollo/client"
import { ChangePartnershipTierModalPartnershipFragment } from "@pallet/features/PartnershipType/ChangePartnershipTierModal/fragments"
import {
    BasePartnershipTierSelectorItemTierFragment,
    BasePartnershipTierSelectorItemApplylistFragment,
} from "../Base/fragment"

export const ChangePartnershipTierSelectorItemTierFragment = gql`
    fragment ChangePartnershipTierSelectorItemTierFragment on CollectivePassType {
        id
        ...BasePartnershipTierSelectorItemTierFragment
    }
    ${BasePartnershipTierSelectorItemTierFragment}
`

export const ChangePartnershipTierSelectorItemApplylistFragment = gql`
    fragment ChangePartnershipTierSelectorItemApplylistFragment on ApplylistType {
        id
        slug
        canEdit
        partnership {
            id
            canRepurchase
            price {
                id
                stripeId
                monthlyUnitAmount
            }
            ...ChangePartnershipTierModalPartnershipFragment
        }
        ...BasePartnershipTierSelectorItemApplylistFragment
    }
    ${BasePartnershipTierSelectorItemApplylistFragment}
    ${ChangePartnershipTierModalPartnershipFragment}
`
